<script setup lang="ts">
import { NodeViewContent, nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3";
import { MailMjmlDocument } from "#components";

defineProps(nodeViewProps);
const store = useMailStore();
</script>

<template>
    <NodeViewWrapper class="document" :as="MailMjmlDocument" :background-color="store.fieldCollection.replaceContent(node.attrs.backgroundColor)
        " :css-class="node.attrs.identifier" @click.stop="store.focusedJsonId = node.attrs.id">
        <NodeViewContent />
    </NodeViewWrapper>
</template>

<style scoped>
.document {
    @apply w-full rounded-xl h-full overflow-auto max-h-full;
}

.document:deep(> div) {
    @apply rounded-xl;
}
</style>
